import type { Routes } from '@angular/router';
import { canActivate } from './auth.guard';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { LoginComponent } from './pages/login/login.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/calls-historic',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
    title: 'NTGY - Iniciar sesión',
  },
  {
    path: '403',
    component: AccessDeniedComponent,
    title: 'NTGY - Acceso denegado',
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./components/dashboard/dashboard-routing.module').then(m => m.DashboardRoutingModule)
    , canActivate: [canActivate]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];

